import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import Auth from '../Auth/Auth';
import LoadingIndicator from './LoadingIndicator';
import { withRouter } from 'react-router';
import ErrorNotification from './common/ErrorNotification';
import { PROPEL_URL_KEY } from '../constants/constants';
import { AppContext } from './../AppProvider';
import { isPermissible } from './Global/PermissionResolver';

export class AuthenticatedRoute extends Component {
  static propTypes = {
    component: PropTypes.func.isRequired,
    auth: PropTypes.instanceOf(Auth),
    isPermitted: PropTypes.func.isRequired,
    requiresAuthentication: PropTypes.bool.isRequired
  };
  state = { error: null, loading: true, globalProps: {} };

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }
  componentDidMount() {
    // If we aren't authenticated then let this page render (set loading to false) since that'll trigger the
    // login and we'll end up back here as authenticated and then get the props.
    if (!this.props.auth.isAuthenticated()) {
      // Not authenticated so save away the URL they used so we can redirect there after login (in Callback)
      localStorage.setItem(PROPEL_URL_KEY, window.location.pathname);
      this.setState({ loading: false });
      return;
    } else {
      this.setState({
        error: null,
        loading: false,
        globalProps: this.context.globalProps
      });
    }
  }

  render() {
    const {
      component: Component,
      auth,
      history,
      isPermitted,
      requiresAuthentication,
      ...rest
    } = this.props;
    const { loading, error, globalProps } = this.state;

    if (loading) {
      return <LoadingIndicator />;
    }
    if (error) {
      return <ErrorNotification message="Error loading page" />;
    }

    return (
      <Route
        {...rest}
        render={props => {
          if (auth.isAuthenticated() || !requiresAuthentication) {
            if (!isPermitted(globalProps, isPermissible)) {
              return <ErrorNotification message="Error loading page" />;
            } else {
              return (
                <Component
                  auth={auth}
                  history={history}
                  {...props}
                  globals={globalProps}
                />
              );
            }
          } else auth.login();
          return <LoadingIndicator />;
        }}
      />
    );
  }
}

export default withRouter(AuthenticatedRoute);
AuthenticatedRoute.contextType = AppContext;
